import { daysMS } from "./date/constant";

// --------------------------------------
export const keyCodes = {
  enter: 13,
  escape: 27,
};

export const isDev =
  process.env.REACT_APP_API_BASE_URL === "https://dev.wildbox.ru/api" ||
  window.location.origin.includes("dev01.wildbox.ru");

// ---------------------------------------------------------------------------------------------------------------------
export function formatNumbers(v) {
  if (!v) return 0;
  const neg = v < 0;
  const x = Math.abs(v);
  const sign = neg ? "- " : "";
  if (x >= 1e9) {
    const b = x / 1e9;
    const t = Number.isInteger(b) ? String(b) : b.toFixed(1).replace(".", ",");
    return `${sign}${t} млрд.`;
  }
  if (x >= 1e6) return `${sign}${Math.round(x / 1e6)} млн.`;
  if (x >= 1e3) return `${sign}${Math.round(x / 1e3)} тыс.`;

  return `${sign}${Math.round(x)}`;
}

export const getHaveNotTrends = createDate =>
  !createDate || new Date("2025-09-15") - new Date(createDate) < 365 * daysMS;

//
export const getCalcSellerData = ({ sellerData, showSimilarData }) => {
  const { diff_sales, weighted_price, percent_sales } = sellerData;
  //
  const calc_orders = percent_sales ? (diff_sales * 100) / percent_sales : 0;
  const calc_proceeds = calc_orders * weighted_price;
  //
  const isCalcTrue = calc_orders > sellerData.orders;
  //
  return {
    ...sellerData,
    orders: {
      param: sellerData.orders,
      ro_param: calc_orders || (showSimilarData ? 0 : undefined),
    },
    proceeds: {
      param: sellerData.proceeds,
      ro_param: calc_proceeds || (showSimilarData ? 0 : undefined),
    },
    ...(showSimilarData && isCalcTrue
      ? {
          dynamic: sellerData.dynamic.map(item => ({
            ...item,
            orders: percent_sales ? (item.diff_sales * 100) / percent_sales : 0,
            proceeds:
              (percent_sales ? (item.diff_sales * 100) / percent_sales : 0) * item.weighted_price,
          })),
        }
      : {}),
  };
};
// ---------------------------------------------------------------------------------------------------------------------
export const productROExtraFields = [
  "ro_proceeds",
  "ro_proceeds_dynamic",
  "ro_orders",
  "ro_orders_dynamic",
  "ro_reviews_diff",
  "ro_reviews_diff_dynamic",
];
// ---------------------------------------------------------------------------------------------------------------------
export const getProductWithROData = ({ data, showSimilarData, isSellerRight = false }) => {
  // Если режим церебро выключен то не меняем данные, но мутируем в объект
  if (!showSimilarData)
    return { ...data, proceeds: { param: data.proceeds }, orders: { param: data.orders } };
  //
  // Если отзывов больше чем выкупов то мы считаем эти данные некорректными, иначе смотрим по продавцу
  const isRight = data.ro_reviews_diff > data.orders ? false : isSellerRight;
  // Если данные верные то мы показываем оригинальные данные. В противном случае показываем большее из заказов
  const showCerebro = isRight ? false : data.ro_orders > data.orders;
  //
  return {
    ...data,
    proceeds: { param: data.proceeds, ro_param: showCerebro ? data.ro_proceeds : null },
    orders: { param: data.orders, ro_param: showCerebro ? data.ro_orders : null },
    ...(showCerebro
      ? { dynamic: data.dynamic.map(i => ({ ...i, proceeds: i.ro_proceeds, orders: i.ro_orders })) }
      : {}),
  };
};
